import React from "react";
import { Artist, SongRequest } from "../../types/type";
import { useToast } from "../../hooks/useToast";

interface FormatCopyButtonProps {
  groupedRequests: { [key: string]: SongRequest[] };
  artistList: Artist[];
}

const FormatCopyButton: React.FC<FormatCopyButtonProps> = ({
  groupedRequests,
  artistList,
}) => {
  const { fireToast } = useToast();

  const formatSongRequestsForClipboard = (
    groupedRequests: { [key: string]: SongRequest[] },
    artistList: Artist[]
  ): string => {
    // 아티스트 정보를 빠르게 조회하기 위한 맵 생성
    const artistMap = new Map(
      artistList.map((artist) => [artist.artistName, artist])
    );

    // Set을 사용하여 중복 제거
    const maleSongs: Set<string> = new Set();
    const femaleSongs: Set<string> = new Set();
    const newArtistSongs: Map<string, Set<string>> = new Map();

    // 각 유저별로 최대 3곡까지만 처리
    Object.values(groupedRequests).forEach((requests) => {
      const userSongs = requests.slice(0, 3);

      userSongs.forEach((request) => {
        const songLine = request.songTitle;

        if (request.existingArtist) {
          if (request.existingArtist.isMale) {
            maleSongs.add(songLine);
          } else {
            femaleSongs.add(songLine);
          }
        } else {
          if (!newArtistSongs.has(request.artistName)) {
            newArtistSongs.set(request.artistName, new Set());
          }
          newArtistSongs.get(request.artistName)?.add(songLine);
        }
      });
    });

    // 결과 문자열 생성
    let result = "";

    // 남자 아티스트 섹션
    if (maleSongs.size > 0) {
      result += "[남자]\n";
      result += Array.from(maleSongs).join("\n");
      result += "\n\n\n";
    }

    // 여자 아티스트 섹션
    if (femaleSongs.size > 0) {
      result += "[여자]\n";
      result += Array.from(femaleSongs).join("\n");
      result += "\n\n\n";
    }

    // 새로운 아티스트 섹션
    newArtistSongs.forEach((songs, artistName) => {
      result += `[${artistName}]\n`;
      result += Array.from(songs).join("\n");
      result += "\n\n\n";
    });

    return result.trim();
  };

  const handleCopyFormattedRequests = () => {
    const formattedText = formatSongRequestsForClipboard(
      groupedRequests,
      artistList
    );
    navigator.clipboard
      .writeText(formattedText)
      .then(() => {
        fireToast({ content: "포맷된 요청 목록이 클립보드에 복사되었습니다." });
      })
      .catch((err) => {
        console.error("클립보드 복사 실패:", err);
        fireToast({ content: "클립보드 복사에 실패했습니다." });
      });
  };

  return <button onClick={handleCopyFormattedRequests}>클립보드 복사</button>;
};

export default FormatCopyButton;
